import App from '@/components/Footer.vue'
import { bootstrapApp } from "@/bootstrapApp";
bootstrapApp(App, 'nonvr-footer');
